import React from "react";
import styles from "./styles.module.scss";
import PDFIcon from "../../../../assets/svg/icons/common/PDFIcon";
import DeleteIcon from "../../../../assets/svg/icons/common/delete";

const FileCard = ({ name, onDelete }) => {
  return (
    <div className={styles.file}>
      <div className={styles.fileIcon}>
        <PDFIcon />
      </div>
      <div className={styles.fileInfo}>
        <span className={styles.fileName}>{name}</span>
      </div>
      {onDelete ? (
        <div className={styles.fileDeleteIcon} onClick={onDelete}>
          <DeleteIcon />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default FileCard;
